const API_HOST = process.env.REACT_APP_API_HOST_URL;

const saveFile = async (blob) => {
  const a = document.createElement("a");
  a.download = `gift-redemption.csv`;
  a.href = URL.createObjectURL(blob);
  a.addEventListener("click", (e) => {
    setTimeout(() => URL.revokeObjectURL(a.href), 30 * 1000);
  });
  a.click();
};

const exportGiftRedemptionList = async ({ id, token }) => {
  let response = await fetch(
    `${API_HOST}/campaignV2/customer/giftRedemption/listExport`,
    {
      method: "Get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  let blob = await response.blob();

  saveFile(blob);
};

export default exportGiftRedemptionList;
